import React from "react";

const ReportTable = ({ columns, data }) => {
  return (
    <div className="report-table-wrapper">
      <table className="report-table">
        <thead>
          <tr>
            {columns.map((col) => {
              const headerKey = col.key || col.dataIndex;
              return (
                <th key={headerKey}>
                  {col.title}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {data && data.length > 0 ? (
            data.map((row, index) => (
              <tr
                key={
                  row.id ||
                  row.customerId ||
                  row.itemId ||
                  row.key ||
                  index
                }
              >
                {columns.map((col) => {
                  const cellKey = col.key || col.dataIndex;
                  const value = row[col.dataIndex];
                  return (
                    <td key={cellKey}>
                      {col.render ? col.render(value, row) : value}
                    </td>
                  );
                })}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={columns.length} className="report-table-empty">
                No data available for this period.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ReportTable;
